var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQrCodeCase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66675 23.8337V8.66699H23.8334V23.8337H8.66675ZM10.8334 21.667H21.6667V10.8337H10.8334V21.667ZM8.66675 43.3337V28.167H23.8334V43.3337H8.66675ZM10.8334 41.167H21.6667V30.3337H10.8334V41.167ZM28.1667 23.8337V8.66699H43.3334V23.8337H28.1667ZM30.3334 21.667H41.1667V10.8337H30.3334V21.667ZM39.5417 43.3337V39.542H43.3334V43.3337H39.5417ZM28.1667 31.9587V28.167H31.9584V31.9587H28.1667ZM31.9584 35.7503V31.9587H35.7501V35.7503H31.9584ZM28.1667 39.542V35.7503H31.9584V39.542H28.1667ZM31.9584 43.3337V39.542H35.7501V43.3337H31.9584ZM35.7501 39.542V35.7503H39.5417V39.542H35.7501ZM35.7501 31.9587V28.167H39.5417V31.9587H35.7501ZM39.5417 35.7503V31.9587H43.3334V35.7503H39.5417Z",
    fill: "#273896"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeCase);
export default __webpack_public_path__ + "static/media/QRCodeCase.9af0526914e83471c473a105bae85e02.svg";
export { ForwardRef as ReactComponent };